<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      &copy; 2026 <a href="/" class="footer-link">{{ $domain }}</a> This site is not affiliated with WhatsApp or Meta. APKs are from third-party sources for educational use only.
    </div>
    <div class="footer-links">
      <a href="/disclaimer/" class="footer-link">Disclaimer</a>
      |
      <a href="/privacy/" class="footer-link">Privacy Policy</a>
      |
      <a href="/about-us/" class="footer-link">About Us</a>
    </div>
</div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  // background-color: #282828;
  background-color: #fff;
  color: #121212;
  padding: 15px 0;
}
@media (max-width: 768px) {
  .footer {
    padding: 10px 0 50px;
  }
}

.footer-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.footer-links {
  display: flex;
  gap: 15px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  font-size: 15px;

  p {
    margin: 0;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
  }

  .footer-links {
    justify-content: center;
    margin-bottom: 10px;
  }

  .footer-note {
    font-size: 10px;
  }
}
</style>
